import { trigger, state, style, transition, animate } from '@angular/animations';

export const mobileSlideState = trigger('mobileSlideState', [
  // Desktop state (fade)
  state('desktopClosed', style({ opacity: 0, visibility: 'hidden' })),
  state('desktopOpen', style({ opacity: 1, visibility: 'visible' })),

  // Mobile state (slide)
  state('mobileClosed', style({ transform: 'translateX(100%)' })),
  state('mobileOpen', style({ transform: 'translateX(0%)' })),

  // Transitions for desktop
  transition('desktopClosed <=> desktopOpen', animate('150ms ease-in-out')),

  // Transitions for mobile
  transition('mobileClosed <=> mobileOpen', animate('350ms cubic-bezier(.2,.8,.2,1)'))
]);
